import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'lib-flexible/flexible'
import './utils/flexible'
import 'lib-flexible'
import App from './App'
import moment from 'moment'
import dateStringToNumber from './utils/stringUtil'
import router from './router'
import Axios from 'axios'
import store from './store/index'
import AMap from 'vue-amap'
import '../theme/index.css'
import "../static/iconfont/iconfont.js"
Vue.config.productionTip = false
Vue.use(Element)

// 跨域相关
Vue.prototype.$axios = Axios
Vue.prototype.$dateStringToNumber = dateStringToNumber
Vue.use(moment)
Vue.use(AMap)

  
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js